import moment from "moment";

export function calculateValidity(startDate, endDate) {
    let start = moment(startDate);
    let end = moment(endDate);
    
    return end.diff(start, 'days');
}